<template>
  <div class="fixed inset-0 bg-scrim/50 transition-all" aria-hidden="true"></div>
</template>
<script lang="ts" setup></script>
